import { createApp } from '@wu/widget-core';
import { BeforeAndAfterSlider } from './before-and-after-slider';
import { meta } from './meta';

export default createApp(meta, BeforeAndAfterSlider);
